import {
  beaconServicePath,
  filterByAllowedNames,
  IMetric,
  isToggleActive,
  METRIC_TYPE,
  normalizeBrowser,
  RawRumData,
  RumData,
  sendValidBeacon,
  TOGGLE_SEND_TO_ELK,
} from "./beacon-util";
import { trackingEndpointLogic } from "../tracking/tracking";
import { rumArray } from "../config/filter-list";
import { getPagecluster } from "@otto-ec/global-resources/misc";
import * as device from "@otto-ec/global-resources/device";

const TOGGLE_SEND_RUM_DATA = "bs_send_rum_data";

/**
 *
 *
 *
 *
 */
export function transformForBeaconService(rumDataRaw: RawRumData): RumData | undefined {
  try {
    const transformedData: RumData = {
      deviceBrowser: normalizeBrowser(rumDataRaw.deviceBrowser),
      deviceOS: rumDataRaw.deviceOS as string,
      pageCluster: rumDataRaw.pagecluster as string,
      rum_deviceType: rumDataRaw.rum_deviceType as string,
      rum_domComplete: <number>rumDataRaw.rum_domComplete,
      beaconType: "rum",
      rumMetrics: filterByAllowedNames(
        rumDataRaw,
        rumArray,
      ) as unknown as IMetric[],
      requestTime: Date.now(),
    };

    if (isToggleActive(TOGGLE_SEND_TO_ELK)) {
      transformedData.url = rumDataRaw.url as string;
      transformedData.rum_sfid = rumDataRaw.rum_sfid as string;
    }

    return transformedData;
    /*                                                         */
  } catch (e) {
    /*                    */
  }
}

/**
 *
 */
export const beaconServicePathRum = `${beaconServicePath}rum`;

export const getTsSfid = (
  tsSfidElement = document.querySelector(".ts-bct"),
): string => tsSfidElement?.getAttribute("data-ts_sfid") ?? "";

const collectRumOnLoad = async () => {
  const navigationTiming = performance.getEntriesByType("navigation")[0];

  const rawRumData: RawRumData = {
    deviceBrowser: device.browser,
    deviceOS: device.os,
    pagecluster: getPagecluster() ?? "unknown",
    rum_deviceType: device.type,
    rum_domComplete: Math.floor(navigationTiming.domComplete),
    rum_sfid: getTsSfid(),
    rum_supportsTouch: (await device.getPointerType()).isTouchable,
    url: window.location.href,
  };

  sendValidBeacon(
    transformForBeaconService(rawRumData),
    beaconServicePathRum,
    TOGGLE_SEND_RUM_DATA,
    METRIC_TYPE.rum,
  );

  trackingEndpointLogic(rawRumData);
};
/**
 *
 */
export const initRumCollection = () => {
  window.addEventListener("load", collectRumOnLoad, { once: true });
};
